"use strict";
// Copyright 2017-2018 Stratumn SAS. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Object.defineProperty(exports, "__esModule", { value: true });
/***** Evidence errors *****/
exports.ErrEvidenceVersionMissing = new TypeError("evidence version is missing");
exports.ErrEvidenceBackendMissing = new TypeError("evidence backend is missing");
exports.ErrEvidenceProviderMissing = new TypeError("evidence provider is missing");
exports.ErrEvidenceProofMissing = new TypeError("evidence proof is missing");
exports.ErrDuplicateEvidence = new TypeError("evidence already exists for the given backend and provider");
/***** Link errors *****/
exports.ErrLinkClientIdUnkown = new TypeError("link was created with an unknown client: can't deserialize it");
exports.ErrLinkHashMissing = new TypeError("link hash is missing");
exports.ErrLinkMapIdMissing = new TypeError("link map id is missing");
exports.ErrLinkMetaMissing = new TypeError("link meta is missing");
exports.ErrLinkProcessMissing = new TypeError("link process is missing");
exports.ErrLinkVersionMissing = new TypeError("link version is missing");
exports.ErrLinkVersionUnknown = new TypeError("unknown link version");
/***** Segment errors *****/
exports.ErrLinkHashMismatch = new TypeError("link hash mismatch");
exports.ErrLinkMissing = new TypeError("link is missing");
exports.ErrSegmentMetaMissing = new TypeError("segment meta is missing");
/***** Signature errors *****/
exports.ErrSignatureInvalid = new TypeError("signature is invalid");
exports.ErrSignatureMissing = new TypeError("signature bytes are missing");
exports.ErrSignaturePublicKeyMissing = new TypeError("signature public key is missing");
exports.ErrSignatureVersionUnknown = new TypeError("unknown signature version");
//# sourceMappingURL=errors.js.map